/* Product photo swiper with a progress bar (product detail below 1024px).
   Markup: snippets/product-media-swiper.liquid. Swiper is loaded globally in
   layout/theme.liquid. */
if (!customElements.get('product-media-swiper')) {
  class ProductMediaSwiper extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;
      if (this.querySelectorAll('.swiper-slide').length < 2) return;

      this.swiper = new Swiper(this.querySelector('.product-media-swiper__swiper'), {
        slidesPerView: 1,
        spaceBetween: 16,
        roundLengths: true,
        grabCursor: true,
        pagination: {
          el: this.querySelector('.product-media-swiper__progress'),
          type: 'progressbar',
        },
      });
    }

    /* Called from section-main-product.js when a variant with its own photo is selected. */
    slideToMedia(mediaId) {
      if (!this.swiper) return;
      const slides = [...this.querySelectorAll('.swiper-slide')];
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) this.swiper.slideTo(index);
    }
  }

  customElements.define('product-media-swiper', ProductMediaSwiper);
}
